var map = {
	"./de/data.json": [
		"a4ac",
		"chunk-2d20884b"
	],
	"./en/data.json": [
		"a50e"
	],
	"./fr/data.json": [
		"e055",
		"chunk-2d224541"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2e28";
module.exports = webpackAsyncContext;